import { render, staticRenderFns } from "./CreateEditPlayer.vue?vue&type=template&id=5b2fa390&scoped=true&"
import script from "./CreateEditPlayer.vue?vue&type=script&lang=js&"
export * from "./CreateEditPlayer.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditPlayer.vue?vue&type=style&index=0&id=5b2fa390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2fa390",
  null
  
)

export default component.exports